import { Key } from "react";

import { datadogRum } from "@datadog/browser-rum";

import { Vero1ConflictCode } from "./persistItem";

const id = (value: Key): string => String(value);

export type Vero1AutosaveTerminal =
  | "saved"
  | "blocked"
  | "conflict"
  | "rejected"
  | "failed";

export type Vero1OutcomeCode =
  | Vero1ConflictCode
  | "severity-unavailable"
  | "name-unavailable";
export type Vero1AutosaveQueueKind = "item" | "report";
export type Vero1BoundaryContext =
  | "vero1_review_panel"
  | "vero1_deal_review_tab";

export const emitAutosaveOutcome = (args: {
  outcome: Vero1AutosaveTerminal;
  conflictCode?: Vero1OutcomeCode | null;
  queue: Vero1AutosaveQueueKind;
  dealId: Key;
  checklistId: Key;
}) => {
  datadogRum.addAction("vero1_autosave_outcome", {
    outcome: args.outcome,
    ...(args.conflictCode ? { conflict_code: args.conflictCode } : {}),
    queue: args.queue,
    deal_id: id(args.dealId),
    checklist_id: id(args.checklistId),
  });
};

export const emitAttestationConflict = (args: {
  conflictCode?: Vero1OutcomeCode | null;
  dealId: Key;
  checklistId: Key;
}) => {
  datadogRum.addAction("vero1_attestation_conflict", {
    ...(args.conflictCode ? { conflict_code: args.conflictCode } : {}),
    deal_id: id(args.dealId),
    checklist_id: id(args.checklistId),
  });
};

export const emitVero1BoundaryError = (
  error: unknown,
  args: {
    context: Vero1BoundaryContext;
    dealId?: Key;
    checklistId?: Key;
  }
) => {
  datadogRum.addError(error, {
    context: args.context,
    ...(args.dealId != null ? { deal_id: id(args.dealId) } : {}),
    ...(args.checklistId != null ? { checklist_id: id(args.checklistId) } : {}),
  });
};
